const customTheme = {
  components: {
    Collapse: {
        colorText: '#999',
        colorTextHeading: '#1677ff',
        contentPadding: "2px 5px 2px 20px",
        headerPadding: "5px 12px"
    },
  },
};

export default customTheme;
